import { Platform } from "../constants";

import { EmailSupport } from "./components/email-support";
import { SetupSection } from "./components/setup-section";
import { URLVerification } from "./components/utms";
import { type PlatformDetails } from "./platform-details";
import { UtmSpendAdditionalDetails } from "./utm-spend-details";

const PLATFORM = Platform.AVANT_LINK;

export const AvantLinkDetails: PlatformDetails = {
  northbeamDocUrl: "",
  officialDocUrl: "",
  additionalDetails: UtmSpendAdditionalDetails(PLATFORM),
};

const SUPPORT_EMAIL_MESSAGE = `Hello AvantLink,

Please add the following UTM parameters to our ads:
nb_platform=avantlink&utm_source=[PUBLISHER_ID]&utm_medium=avantlink&utm_campaign=[AD_NAME]&nb_pid=[PUBLISHER_ID]&nb_wid=[WEBSITE_ID]&nb_tt=[TOOL_TYPE]&nb_aid=[AD_ID]

Thank you!`;

const SUPPORT_EMAIL_MESSAGE_HTML = (
  <>
    <p>Hello AvantLink,</p>
    <p>
      Please add the following UTM parameters to our ads:
      <br />
      <code>
        {/* eslint-disable max-len */}
        nb_platform=avantlink&utm_source=[PUBLISHER_ID]&utm_medium=avantlink&utm_campaign=[AD_NAME]&nb_pid=[PUBLISHER_ID]&nb_wid=[WEBSITE_ID]&nb_tt=[TOOL_TYPE]&nb_aid=[AD_ID]
      </code>
    </p>
    <p>Thank you!</p>
  </>
);

export const AvantLinkSetup = () => (
  <>
    <SetupSection
      title="Email customer support at AvantLink. We suggest using the provided
        message."
    >
      <EmailSupport
        emailAddress="support@avantlink.com"
        message={SUPPORT_EMAIL_MESSAGE}
        messageContent={SUPPORT_EMAIL_MESSAGE_HTML}
      />
    </SetupSection>
    <URLVerification platform={PLATFORM} />
  </>
);
